module.exports = __webpack_public_path__ + "img/exam (5).eb118761.jpeg";